import ReportsPage from "@/views/Reports/ReportsPage.vue";
const routes = [
    {
        path: "/reports/generate",
        name: "ReportsPage",
        component: ReportsPage,
    },
];
export default routes;
